/* eslint-disable  */
import {connect} from 'react-redux';
import React from 'react';
import { openCurriculumPanel, closeCurriculumPanel } from "../reducers/cmra-curriculum.js";
import { BsArrowBarRight, BsArrowBarLeft } from "react-icons/bs";

class ToolBar extends React.Component {
  constructor () {
    super();
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  
  render () {
    const buttonStyle = {
      // backgroundColor: "red",
      backgroundColor: "white",
      border: "2px solid lightgray",
      borderRadius: 1000,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      width: 36,
      height: 36,
    }

    const iconStyle = {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center"
    }

    return(
      <div className={this.props.style}>{this.props.children}
      {this.props.isOpen ?
        <a onClick={this.handleClose} style={buttonStyle}>
          <span style={iconStyle}><BsArrowBarRight/></span>
        </a>
        :
        <a onClick={this.handleOpen} style={buttonStyle}>
          <span style={iconStyle}><BsArrowBarLeft/></span>
        </a>
      }
    </div>
    )
  }

  handleOpen () {
    this.props.openCurriculumPanel();
  }
  handleClose () {
    this.props.closeCurriculumPanel();
  }
}

const mapStateToProps = state => {
  return{isOpen: state.scratchGui.cmraCurriculum.isOpen}
}

export default connect(mapStateToProps, {openCurriculumPanel, closeCurriculumPanel})(ToolBar);


